/**
 *   Generated file. Do not edit
 */

import { LocalTime } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readLocalTime(): LocalTime;
  }
  export interface TapStreamWriter {
    writeLocalTime(model: LocalTime): TapStreamWriter;
  }
}

TapStreamReader.prototype.readLocalTime = function (): LocalTime {
  const model: Partial<LocalTime> = {};

  model.seconds = this.readUnsigned(4);

  model.minutes = this.readUnsigned(4);

  model.hours = this.readUnsigned(4);

  model.dayOfMonth = this.readUnsigned(4);

  model.month = this.readUnsigned(4);

  model.year = this.readUnsigned(4);

  model.dayOfWeek = this.readUnsigned(4);

  model.dayOfYear = this.readUnsigned(4);

  model.isdst = this.readUnsigned(4);

  return model as LocalTime;
};

// TapStreamWriter.prototype.write(model: LocalTime) : TapStreamWriter{
//     return this.writeLocalTime(model)
// }

TapStreamWriter.prototype.writeLocalTime = function (
  model: LocalTime,
): TapStreamWriter {
  this.writeUnsigned(model.seconds, 4);

  this.writeUnsigned(model.minutes, 4);

  this.writeUnsigned(model.hours, 4);

  this.writeUnsigned(model.dayOfMonth, 4);

  this.writeUnsigned(model.month, 4);

  this.writeUnsigned(model.year, 4);

  this.writeUnsigned(model.dayOfWeek, 4);

  this.writeUnsigned(model.dayOfYear, 4);

  this.writeUnsigned(model.isdst, 4);

  return this;
};
